import './Fees.css';

export const Fees = () => {
  return (
    <>
      <section className="snn-page-section">
        <h1 className="snn-title">Registration Fees</h1>
        <p>Login to get instructions for payment and upload the recipt</p>
        <table className="snn-table-fees">
          <thead>
            <tr>
              <th></th>
              <th>Student</th>
              <th>
                Researcher/
                <br />
                Postdoc
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Early Bird, April 1 to April 15, 2024</td>
              <td className="snn-prices-cell">$700.00</td>
              <td className="snn-prices-cell">$1,400.00</td>
            </tr>
            <tr>
              <td>After April 15th, 2024</td>
              <td className="snn-prices-cell">$1,000.00</td>
              <td className="snn-prices-cell">$2,000.00</td>
            </tr>
          </tbody>
        </table>
        <p>Note: Registration Fees in Mexican pesos</p>
      </section>
      <section className="snn-page-section">
        <h1 className="snn-title">Fellowships</h1>
        <p>
          <strong>Attention students:</strong> All undergraduate, master&apos;s, and doctoral
          students whose abstracts have been accepted and are presenting them will be entitled to a
          scholarship. On Tuesday the 9th, the scholarship system will be available on our website.
          Remember, you will need current proof of your student status.
        </p>
        <p>Login to get instructions for scholarship submission and upload the proof of student.</p>
      </section>
    </>
  );
};
